<script>
import SongViewModal from "../components/SongViewModal.vue";

export default {
  name: "SongListAll",
  components: { SongViewModal },
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      loading: true,
      error: "",
      search: "",
      page: 1,
      perPage: 10,
      totalPages: 1,
      from: 0,
      to: 0,
      total: 0,
      rows: [],
      overview: "",
      stats: { total: 0, with_iswc: 0, without_iswc: 0, with_publisher: 0, this_month: 0 },
      debounceTimer: null,
      deletingId: "",
      modal: {
        title: "ข้อมูลเบื้องต้น",
        workId: "-",
        songTitle: "-",
        people: [],
        lines: [],
      },
    };
  },
  computed: {
    metaText: function () {
      if (this.loading) {
        return "กำลังค้นหา...";
      }
      if (this.error) {
        return "เกิดข้อผิดพลาด";
      }
      return "แสดงผลหน้า " + this.page + " / " + this.totalPages;
    },
    pageInfoText: function () {
      if (this.loading || this.error) {
        return "-";
      }
      return "แสดง " + this.from + "-" + this.to + " จากทั้งหมด " + this.total + " รายการ";
    },
    canDelete: function () {
      if (!this.config || typeof this.config.canDelete === "undefined") {
        return true;
      }
      return !!this.config.canDelete;
    },
    canAdd: function () {
      if (!this.config || typeof this.config.canAdd === "undefined") {
        return true;
      }
      return !!this.config.canAdd;
    },
    songAddHref: function () {
      return String((this.config && this.config.songAddHref) || "main-manage-song.php?page=song_add");
    },
    songDetailApiUrl: function () {
      var fromConfig = String((this.config && this.config.songDetailApiUrl) || "").trim();
      var base;
      if (fromConfig) {
        return fromConfig;
      }
      base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/actions/song-detail.php";
    },
    pageNumbers: function () {
      var start = Math.max(1, this.page - 2);
      var end = Math.min(this.totalPages, start + 4);
      start = Math.max(1, end - 4);
      var nums = [];
      var i;
      for (i = start; i <= end; i++) {
        nums.push(i);
      }
      return nums;
    },
    displayRows: function () {
      var self = this;
      return this.rows.map(function (row) {
        return {
          row: row,
          melodyPeople: self.parseRolePeople(row.melody_member_names),
          lyricsPeople: self.parseRolePeople(row.lyrics_member_names),
          arrangementPeople: self.parseRolePeople(row.arrangement_member_names),
          publisherPeople: self.parseRolePeople(row.publisher_member_names),
        };
      });
    },
  },
  mounted: function () {
    this.loadSongs(1);
  },
  beforeUnmount: function () {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    safeText: function (value) {
      var t = String(value || "").trim();
      return t === "" ? "-" : t;
    },
    hasText: function (value) {
      return String(value || "").trim() !== "";
    },
    formatSongDate: function (value) {
      var t = String(value || "").trim();
      if (!t) {
        return "-";
      }
      return t.length >= 10 ? t.slice(0, 10) : t;
    },
    parseRolePeople: function (value) {
      var txt = String(value || "").trim();
      var parts;
      var i;
      var people = [];
      if (txt === "") {
        return people;
      }
      parts = txt.split(",");
      for (i = 0; i < parts.length; i++) {
        var raw = String(parts[i] || "").trim();
        var m;
        var displayName;
        var nameType;
        var initial;
        if (raw === "") {
          continue;
        }
        m = raw.match(/^(.*)\s*\(([^()]+)\)\s*$/);
        displayName = m ? String(m[1] || "").trim() : raw;
        nameType = m ? String(m[2] || "").trim() : "";
        initial = displayName.charAt(0).toUpperCase();
        if (initial === "") {
          initial = "?";
        }
        people.push({ displayName: displayName, nameType: nameType, initial: initial });
      }
      return people;
    },
    splitNameLines: function (value) {
      var txt = String(value || "").trim();
      var parts;
      var out = [];
      var i;
      var name;
      if (txt === "") {
        return out;
      }
      parts = txt.split(/\r\n|\n|\r|\s*\/\s*/);
      if (parts.length <= 1 && txt.indexOf(",") !== -1) {
        parts = txt.split(",");
      }
      for (i = 0; i < parts.length; i++) {
        name = String(parts[i] || "").trim();
        if (name) {
          out.push(name);
        }
      }
      return out;
    },
    viewHref: function (workId) {
      var base = String((this.config && this.config.basePath) || "");
      var prefix = base === "" ? "" : base;
      return prefix + "/main-manage-song.php?page=song_view&work_id=" + encodeURIComponent(this.safeText(workId) === "-" ? "" : String(workId || "").trim());
    },
    openView: function (workId) {
      var id = String(workId || "").trim();
      if (!id) {
        return;
      }
      if (this.$refs.songViewModal && typeof this.$refs.songViewModal.open === "function") {
        this.$refs.songViewModal.open(id);
        return;
      }
      window.location.href = this.viewHref(id);
    },
    loadSongs: function (page) {
      var self = this;
      var apiUrl = String((this.config && this.config.apiUrl) || "").trim();
      this.page = Math.max(1, Number(page || 1));
      this.perPage = this.perPage === 25 || this.perPage === 50 ? this.perPage : 10;
      this.loading = true;
      this.error = "";
      if (apiUrl === "") {
        this.loading = false;
        this.error = "ไม่พบที่อยู่ API ของรายการเพลง";
        return;
      }
      var params = new URLSearchParams();
      params.set("page", String(this.page));
      params.set("per_page", String(this.perPage));
      params.set("search", String(this.search || "").trim());
      params.set("overview", String(this.overview || "").trim());
      fetch(apiUrl + "?" + params.toString(), {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (res) {
          return res.text().then(function (txt) {
            return { ok: res.ok, txt: txt };
          });
        })
        .then(function (payload) {
          var data = {};
          try {
            data = payload.txt ? JSON.parse(payload.txt) : {};
          } catch (e) {
            throw new Error("API ตอบกลับไม่ถูกต้อง");
          }
          if (!payload.ok || !data || data.success !== true) {
            throw new Error(data && data.message ? data.message : "ไม่สามารถโหลดรายการเพลงได้");
          }
          self.rows = Array.isArray(data.rows) ? data.rows : [];
          self.page = Number(data.page || 1);
          self.totalPages = Math.max(1, Number(data.total_pages || 1));
          self.from = Number(data.from || 0);
          self.to = Number(data.to || 0);
          self.total = Number(data.total || 0);
          var pp = Number(data.per_page || self.perPage);
          if (pp === 10 || pp === 25 || pp === 50) {
            self.perPage = pp;
          }
          self.stats = Object.assign(
            { total: 0, with_iswc: 0, without_iswc: 0, with_publisher: 0, this_month: 0 },
            data.stats || {}
          );
          self.loading = false;
        })
        .catch(function (err) {
          self.loading = false;
          self.rows = [];
          self.error = err && err.message ? err.message : "เกิดข้อผิดพลาดในการโหลดข้อมูล";
        });
    },
    debounceLoad: function () {
      var self = this;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        self.loadSongs(1);
      }, 300);
    },
    onPerPageChange: function () {
      var v = Number(this.perPage);
      this.perPage = v === 25 || v === 50 ? v : 10;
      this.loadSongs(1);
    },
    clearFilters: function () {
      this.search = "";
      this.overview = "";
      this.perPage = 10;
      this.loadSongs(1);
    },
    activateOverview: function (next) {
      var n = String(next || "");
      if (n === "") {
        this.overview = "";
      } else {
        this.overview = this.overview === n ? "" : n;
      }
      this.loadSongs(1);
    },
    onStatKey: function (event, next) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.activateOverview(next);
      }
    },
    openRoleModal: function (roleLabel, roleValue, workId, songTitle) {
      var self = this;
      var raw = String(roleValue || "").trim();
      var lines = [];
      if (raw !== "") {
        lines = raw.split("||").map(function (s) {
          return String(s || "").trim();
        }).filter(function (s) {
          return s !== "";
        });
      }
      this.modal = {
        title: "ข้อมูลเบื้องต้น - " + String(roleLabel || "-"),
        workId: this.safeText(workId),
        songTitle: this.safeText(songTitle),
        people: lines.length ? [] : this.parseRolePeople(raw),
        lines: lines,
      };
      this.$nextTick(function () {
        var el = self.$refs.roleModal;
        if (!el || !window.bootstrap || !window.bootstrap.Modal) {
          return;
        }
        window.bootstrap.Modal.getOrCreateInstance(el).show();
      });
    },
    deleteSong: function (workId) {
      var self = this;
      var id = String(workId || "").trim();
      var deleteApi = String((this.config && this.config.deleteApiUrl) || "").trim();
      var body;
      if (!this.canDelete || !id || !deleteApi) {
        return;
      }
      if (!window.confirm("ยืนยันการลบเพลง Work ID: " + id + " ?")) {
        return;
      }
      this.deletingId = id;
      this.error = "";
      body = new URLSearchParams();
      body.set("work_id", id);
      fetch(deleteApi, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: body.toString(),
      })
        .then(function (res) {
          return res.text().then(function (txt) {
            return { ok: res.ok, txt: txt };
          });
        })
        .then(function (payload) {
          var data = {};
          try {
            data = payload.txt ? JSON.parse(payload.txt) : {};
          } catch (e) {
            throw new Error("API ตอบกลับไม่ถูกต้อง");
          }
          if (!payload.ok || !data || data.success !== true) {
            throw new Error(data && data.message ? data.message : "ไม่สามารถลบข้อมูลเพลงได้");
          }
          self.deletingId = "";
          self.loadSongs(self.page);
        })
        .catch(function (err) {
          self.deletingId = "";
          self.error = err && err.message ? err.message : "ลบข้อมูลไม่สำเร็จ";
        });
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
          <h4 class="mb-sm-0"><i class="ri-music-2-line me-1 align-middle"></i>รายการเพลงทั้งหมด</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript:void(0);">จัดการเพลง</a></li>
              <li class="breadcrumb-item active">รายการเพลงทั้งหมด</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
      {{ error }}
      <button type="button" class="btn-close" aria-label="ปิด" @click="error = ''"></button>
    </div>

    <div class="row g-3 mb-3 row-cols-2 row-cols-xl-5">
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-light border rounded-3 song-stat-card"
          :class="{ 'is-active': overview === '' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อแสดงเพลงทั้งหมด"
          :aria-pressed="overview === '' ? 'true' : 'false'"
          @click="activateOverview('')"
          @keydown="onStatKey($event, '')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-muted mb-1 small">ทั้งหมด</p>
                <h3 class="mb-0 fw-bold">{{ stats.total || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-4">
                  <i class="ri-music-2-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-primary-subtle border border-primary border-opacity-50 rounded-3 song-stat-card"
          :class="{ 'is-active': overview === 'has_iswc' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อกรองเพลงที่มี ISWC"
          :aria-pressed="overview === 'has_iswc' ? 'true' : 'false'"
          @click="activateOverview('has_iswc')"
          @keydown="onStatKey($event, 'has_iswc')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-primary-emphasis mb-1 small">มี ISWC</p>
                <h3 class="mb-0 fw-bold text-primary">{{ stats.with_iswc || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-primary-subtle text-primary rounded-circle fs-4">
                  <i class="ri-hashtag"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-warning-subtle border border-warning border-opacity-50 rounded-3 song-stat-card"
          :class="{ 'is-active': overview === 'no_iswc' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อกรองเพลงที่ยังไม่มี ISWC"
          :aria-pressed="overview === 'no_iswc' ? 'true' : 'false'"
          @click="activateOverview('no_iswc')"
          @keydown="onStatKey($event, 'no_iswc')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-warning-emphasis mb-1 small">ยังไม่มี ISWC</p>
                <h3 class="mb-0 fw-bold text-warning">{{ stats.without_iswc || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-warning-subtle text-warning rounded-circle fs-4">
                  <i class="ri-error-warning-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-success-subtle border border-success border-opacity-50 rounded-3 song-stat-card"
          :class="{ 'is-active': overview === 'has_publisher' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อกรองเพลงที่มี Publisher"
          :aria-pressed="overview === 'has_publisher' ? 'true' : 'false'"
          @click="activateOverview('has_publisher')"
          @keydown="onStatKey($event, 'has_publisher')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-success-emphasis mb-1 small">มี Publisher</p>
                <h3 class="mb-0 fw-bold text-success">{{ stats.with_publisher || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-success-subtle text-success rounded-circle fs-4">
                  <i class="ri-building-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div
          class="card card-animate h-100 shadow-sm bg-info-subtle border border-info border-opacity-50 rounded-3 song-stat-card"
          :class="{ 'is-active': overview === 'this_month' }"
          role="button"
          tabindex="0"
          title="คลิกเพื่อกรองเพลงที่บันทึกเดือนนี้"
          :aria-pressed="overview === 'this_month' ? 'true' : 'false'"
          @click="activateOverview('this_month')"
          @keydown="onStatKey($event, 'this_month')"
        >
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <p class="text-uppercase fw-semibold text-info-emphasis mb-1 small">เดือนนี้</p>
                <h3 class="mb-0 fw-bold text-info">{{ stats.this_month || 0 }}</h3>
              </div>
              <div class="avatar-sm flex-shrink-0">
                <span class="avatar-title bg-info-subtle text-info rounded-circle fs-4">
                  <i class="ri-calendar-check-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-12">
            <label class="form-label" for="song-search-keyword">ค้นหาเพลง / รหัสผลงาน / ISWC</label>
            <div class="input-group">
              <span class="input-group-text"><i class="ri-search-line"></i></span>
              <input
                id="song-search-keyword"
                v-model="search"
                type="text"
                class="form-control"
                placeholder="ค้นหาได้ทั้งชื่อเพลง, Work ID, ISWC, ISRC, ทำนอง, เนื้อร้อง, เรียบเรียง, Publisher"
                @input="debounceLoad"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h4 class="card-title mb-0">Table - รายการเพลง</h4>
        <div class="d-flex flex-wrap align-items-center gap-2">
          <span class="text-muted">{{ metaText }}</span>
          <a v-if="canAdd" class="btn btn-primary btn-sm" :href="songAddHref">
            <i class="ri-add-line align-bottom me-1"></i>เพิ่มเพลง
          </a>
          <button type="button" class="btn btn-soft-secondary btn-sm" @click="clearFilters">
            <i class="ri-filter-off-line align-bottom me-1"></i>ล้างตัวกรอง
          </button>
          <button type="button" class="btn btn-soft-secondary btn-sm" @click="loadSongs(page)">
            <i class="ri-refresh-line align-bottom me-1"></i>รีเฟรชข้อมูล
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive table-card mt-3 mb-1">
          <table class="table align-middle table-nowrap table-striped table-xs mb-0 table-bordered table-primary table-hover song-list-table">
            <thead class="table-light">
              <tr>
                <th>รหัสผลงาน</th>
                <th>ชื่อเพลง</th>
                <th>ศิลปิน</th>
                <th class="song-role-col">ทำนอง</th>
                <th class="song-role-col">เนื้อร้อง</th>
                <th class="song-role-col">เรียบเรียง</th>
                <th class="song-publisher-col">Publisher</th>
                <th>วันที่บันทึก</th>
                <th style="width: 88px;">ดำเนินการ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="9" class="text-muted">กำลังโหลดข้อมูล...</td>
              </tr>
              <tr v-else-if="error && rows.length === 0">
                <td colspan="9" class="text-danger">โหลดข้อมูลไม่สำเร็จ</td>
              </tr>
              <tr v-else-if="displayRows.length === 0">
                <td colspan="9" class="text-muted">ไม่พบข้อมูลเพลง</td>
              </tr>
              <template v-else>
                <tr v-for="item in displayRows" :key="item.row.work_id" class="song-data-row" @click="openView(item.row.work_id)">
                  <td>
                    <div class="small lh-sm">
                      <div class="fw-semibold">
                        <i class="ri-barcode-line text-muted me-1 align-middle"></i>{{ safeText(item.row.work_id) }}
                      </div>
                      <div v-if="hasText(item.row.iswc)" class="mt-1">
                        <i class="ri-hashtag text-muted me-1 align-middle"></i>ISWC {{ String(item.row.iswc || "").trim() }}
                      </div>
                      <div v-if="hasText(item.row.isrc)" class="mt-1">
                        <i class="ri-disc-line text-muted me-1 align-middle"></i>ISRC {{ String(item.row.isrc || "").trim() }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="lh-sm">
                      <div>{{ hasText(item.row.title_local) ? String(item.row.title_local).trim() : "-" }}</div>
                      <div v-if="hasText(item.row.title_eng)" class="small text-muted">{{ String(item.row.title_eng).trim() }}</div>
                    </div>
                  </td>
                  <td>
                    <div v-if="splitNameLines(item.row.artist_name).length" class="lh-sm" :title="splitNameLines(item.row.artist_name).join(' / ')">
                      <div v-for="(name, i) in splitNameLines(item.row.artist_name)" :key="'artist-' + i">
                        <i v-if="i === 0" class="ri-mic-line text-muted me-1 align-middle"></i><span :class="{ 'ms-3': i > 0 }">{{ name }}</span>
                      </div>
                    </div>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td class="song-role-col song-role-wrap" @click.stop="openRoleModal('ทำนอง', item.row.melody_member_details || item.row.melody_member_names, item.row.work_id, item.row.title_local)">
                    <div v-for="(person, i) in item.melodyPeople" :key="'m-' + i" class="song-role-person">
                      <span class="avatar-xxs d-inline-flex align-items-center justify-content-center rounded-circle border border-light-subtle bg-light text-muted fw-semibold">{{ person.initial }}</span>
                      <span>{{ person.displayName }}<span v-if="person.nameType" class="song-name-type-badge">{{ person.nameType }}</span></span>
                    </div>
                    <template v-if="!item.melodyPeople.length">-</template>
                  </td>
                  <td class="song-role-col song-role-wrap" @click.stop="openRoleModal('เนื้อร้อง', item.row.lyrics_member_details || item.row.lyrics_member_names, item.row.work_id, item.row.title_local)">
                    <div v-for="(person, i) in item.lyricsPeople" :key="'l-' + i" class="song-role-person">
                      <span class="avatar-xxs d-inline-flex align-items-center justify-content-center rounded-circle border border-light-subtle bg-light text-muted fw-semibold">{{ person.initial }}</span>
                      <span>{{ person.displayName }}<span v-if="person.nameType" class="song-name-type-badge">{{ person.nameType }}</span></span>
                    </div>
                    <template v-if="!item.lyricsPeople.length">-</template>
                  </td>
                  <td class="song-role-col song-role-wrap" @click.stop="openRoleModal('เรียบเรียง', item.row.arrangement_member_details || item.row.arrangement_member_names, item.row.work_id, item.row.title_local)">
                    <div v-for="(person, i) in item.arrangementPeople" :key="'a-' + i" class="song-role-person">
                      <span class="avatar-xxs d-inline-flex align-items-center justify-content-center rounded-circle border border-light-subtle bg-light text-muted fw-semibold">{{ person.initial }}</span>
                      <span>{{ person.displayName }}<span v-if="person.nameType" class="song-name-type-badge">{{ person.nameType }}</span></span>
                    </div>
                    <template v-if="!item.arrangementPeople.length">-</template>
                  </td>
                  <td class="song-publisher-col song-role-wrap" @click.stop="openRoleModal('Publisher', item.row.publisher_member_details || item.row.publisher_member_names, item.row.work_id, item.row.title_local)">
                    <div v-for="(person, i) in item.publisherPeople" :key="'p-' + i" class="song-role-person">
                      <span class="avatar-xxs d-inline-flex align-items-center justify-content-center rounded-circle border border-light-subtle bg-light text-muted fw-semibold">{{ person.initial }}</span>
                      <span>{{ person.displayName }}<span v-if="person.nameType" class="song-name-type-badge">{{ person.nameType }}</span></span>
                    </div>
                    <template v-if="!item.publisherPeople.length">-</template>
                  </td>
                  <td>{{ formatSongDate(item.row.created_at) }}</td>
                  <td class="text-nowrap" @click.stop>
                    <div class="d-flex gap-1">
                      <button type="button" class="btn btn-sm btn-soft-info btn-icon" title="ดูข้อมูลเพลง" aria-label="ดูข้อมูลเพลง" @click="openView(item.row.work_id)">
                        <i class="ri-eye-line fs-16"></i>
                      </button>
                      <button
                        v-if="canDelete"
                        type="button"
                        class="btn btn-sm btn-soft-danger btn-icon"
                        title="ลบเพลง"
                        aria-label="ลบเพลง"
                        :disabled="deletingId === String(item.row.work_id || '').trim()"
                        @click="deleteSong(item.row.work_id)"
                      >
                        <i class="ri-delete-bin-line fs-16"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mt-3">
          <div class="d-flex flex-wrap align-items-center gap-3">
            <small class="text-muted">{{ pageInfoText }}</small>
            <div class="d-flex align-items-center gap-2">
              <label class="form-label text-muted small mb-0" for="song-per-page">แถวต่อหน้า</label>
              <select id="song-per-page" v-model.number="perPage" class="form-select form-select-sm" style="width: 4.75rem" aria-label="จำนวนแถวต่อหน้า" @change="onPerPageChange">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
              </select>
            </div>
          </div>
          <div class="pagination-wrap hstack gap-2">
            <button type="button" class="btn btn-sm btn-light" :disabled="page <= 1" @click="loadSongs(page - 1)">ก่อนหน้า</button>
            <ul class="pagination listjs-pagination mb-0">
              <li v-for="n in pageNumbers" :key="n" class="page-item" :class="{ active: n === page }">
                <button type="button" class="page-link" @click="loadSongs(n)">{{ n }}</button>
              </li>
            </ul>
            <button type="button" class="btn btn-sm btn-light" :disabled="page >= totalPages" @click="loadSongs(page + 1)">ถัดไป</button>
          </div>
        </div>
      </div>
    </div>

    <div ref="roleModal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modal.title }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="small text-muted mb-1">Work ID</div>
            <div class="fw-semibold mb-2">{{ modal.workId }}</div>
            <div class="small text-muted mb-1">ชื่อเพลง</div>
            <div class="fw-semibold mb-3">{{ modal.songTitle }}</div>
            <div class="small text-muted mb-2">รายชื่อ</div>
            <div class="song-role-modal-list">
              <div v-if="modal.lines.length">
                <div v-for="(line, i) in modal.lines" :key="i" class="border rounded-2 p-2 mb-2 bg-light-subtle">{{ line }}</div>
              </div>
              <div v-else-if="modal.people.length">
                <div v-for="(person, i) in modal.people" :key="i" class="song-role-person">
                  <span class="avatar-xxs d-inline-flex align-items-center justify-content-center rounded-circle border border-light-subtle bg-light text-muted fw-semibold">{{ person.initial }}</span>
                  <span>{{ person.displayName }}<span v-if="person.nameType" class="song-name-type-badge">{{ person.nameType }}</span></span>
                </div>
              </div>
              <template v-else>-</template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <song-view-modal
      ref="songViewModal"
      :api-url="songDetailApiUrl"
      :base-path="config && config.basePath"
      :show-actions="true"
    />
  </div>
</template>

<style>
.song-list-table thead.table-light th {
  background: #eff6ff !important;
  color: #1e3a8a;
  border-color: #bfdbfe;
}
.song-list-table tbody tr:nth-of-type(odd) {
  background-color: #f8fbff;
}
.song-list-table tbody tr:hover {
  background-color: #eaf2ff !important;
}
.song-list-table td,
.song-list-table th {
  border-color: #dbeafe !important;
}
.song-role-col {
  width: 270px;
  min-width: 270px;
  max-width: 270px;
}
.song-publisher-col {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
}
.song-role-wrap {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 220px;
  vertical-align: top;
  line-height: 1.35;
  cursor: pointer;
}
.song-role-person {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  margin-bottom: 0.25rem;
}
.song-name-type-badge {
  display: inline-block;
  margin-left: 0.35rem;
  padding: 0.1rem 0.4rem;
  border: 1px solid #94a3b8;
  border-radius: 999px;
  font-size: 0.7rem;
  line-height: 1.2;
  color: #334155;
  background: #f8fafc;
  vertical-align: middle;
  font-weight: 600;
}
.song-role-modal-list {
  max-height: 260px;
  overflow: auto;
}
tr.song-data-row {
  cursor: pointer;
}
.song-stat-card {
  cursor: pointer;
}
.song-stat-card.is-active {
  outline: 2px solid rgba(33, 37, 41, 0.35);
  outline-offset: 1px;
}
</style>
